var _path, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74978 11V2.5C8.74978 2.22386 8.97364 2 9.24978 2V2C9.52592 2 9.74978 2.22386 9.74978 2.5V11C9.74978 11.4133 9.62989 12.0222 9.25555 12.5422C8.86285 13.0876 8.21274 13.5 7.24978 13.5H5.75074C5.39475 13.5 4.8615 13.5887 4.43699 13.8333C4.16436 13.9903 3.94398 14.2037 3.83144 14.5093C3.73602 14.7684 3.52614 15 3.25 15V15C2.97386 15 2.74356 14.7737 2.79727 14.5028C2.943 13.7679 3.40767 13.2721 3.93784 12.9667C4.52862 12.6264 5.21156 12.5099 5.6875 12.5006L7.24978 12.5C7.88682 12.5 8.23671 12.2458 8.44401 11.9578C8.66967 11.6444 8.74978 11.2533 8.74978 11Z",
    fill: "#333333"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.5,
    width: 1.5,
    height: 13,
    rx: 0.75,
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 0.5,
    width: 1.5,
    height: 13,
    rx: 0.75,
    fill: "#333333"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 2,
    width: 1,
    height: 9,
    rx: 0.5,
    fill: "#333333"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 2,
    width: 1,
    height: 9,
    rx: 0.5,
    fill: "#333333"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 2,
    width: 1,
    height: 9,
    rx: 0.5,
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterial);
export default __webpack_public_path__ + "static/media/material.3b7f7578f33dd017818ef2b5c898f342.svg";
export { ForwardRef as ReactComponent };